import baron from "baron";

export default function PartnersPreviews(container) {
  scrollBlock(container);

  function scrollBlock(baseElement) {
    const partnersPreviewsBaseClass = "partners-previews";

    const baronScrollerContainer = baseElement;

    const modalBoxScrollTrack = document.createElement("div");
    modalBoxScrollTrack.className = `${partnersPreviewsBaseClass}__scrolltrack`;

    const modalBoxScrollBar = document.createElement("div");
    modalBoxScrollBar.className = `${partnersPreviewsBaseClass}__scrollbar`;

    modalBoxScrollTrack.appendChild(modalBoxScrollBar);
    baronScrollerContainer.appendChild(modalBoxScrollTrack);

    const customScroller = baron({
      cssGuru: true,
      root: baronScrollerContainer,
      scroller: baronScrollerContainer,
      barOnCls: `${partnersPreviewsBaseClass}__scroll-content_scrolling`,
      bar: modalBoxScrollBar,
      direction: "v"
    });

    customScroller.controls({
      track: modalBoxScrollTrack
    });

    baronScrollerContainer.style.display = "block";
    customScroller.update();
    baronScrollerContainer.style.display = "";
  }
}
